export default __webpack_public_path__ + "static/Blue_Mosque_Istanbul_Turkey-2895ccf70eb09a2414bdaff0dbad5cc3.jpg";